module.exports = __webpack_public_path__ + "static/media/chronic.2077bd74.svg";